import Vue from 'vue';
import Vuetify from 'vuetify/lib';
/* @ts-ignore: vuetify does not come with type annotations for locales: */
import de from 'vuetify/lib/locale/de';
/* @ts-ignore: vuetify does not come with type annotations for locales: */
import en from 'vuetify/lib/locale/en';
import { userInfo } from '@/helpers/globals';
import { vuetifyThemeColors } from '@/customer-specific';

Vue.use(Vuetify);

const locale = userInfo().locale || 'de';

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
            variations: false,
        },
        themes: {
            light: vuetifyThemeColors(),
        },
    },
    lang: {
        locales: { de, en },
        current: locale,
    },

    icons: {
        // ic is defined in main.scss
        // iconfont: 'ic',
        // see https://github.com/vuetifyjs/vuetify/blob/master/packages/vuetify/src/services/icons/presets/fa.ts
        values: {
            checkboxOff: 'ic-20 ic-checkboxunchecked ic-col-grey',
            checkboxOn: 'ic-20 ic-checkboxchecked ic-col-grey',
            checkboxIndeterminate: 'ic-20 ic-checkbox-partial ic-col-grey',
            dropdown: 'ic-16 ic-arrowdown ic-col-black',
            cancel: 'ic-16 ic-x ic-col-white',
            error: 'ic-16 ic-x ic-col-white',
            sort: 'ic-16 ic-arrowdown ic-col-black',
            first: 'ic-20 ic-first ic-col-grey',
            last: 'ic-20 ic-last ic-col-grey',
            loading: 'ic-16 ic-load ic-col-grey ic-spin',
            info: 'ic-20 ic-info ic-col-white',
            radioOff: 'ic-20 ic-radio ic-col-grey',
            radioOn: 'ic-20 ic-radioactive ic-col-grey',
            prev: 'ic-20 ic-prev ic-col-grey',
            next: 'ic-20 ic-next ic-col-grey',
            expand: 'ic-20 ic-next ic-col-grey',
            subgroup: 'ic-16 ic-arrowdown ic-col-grey',
            clear: 'ic-20 ic-x ic-col-grey',
            delete: 'ic-16 ic-x ic-col-grey',
        },
    },
});
